export default "__VITE_ASSET__BAKa4GKf__"